import { TextWithTooltip } from 'hooks/TextWithTooltip';
import styles from './BannerErrorEmployeds.module.scss';
import classNames from 'classnames';

export const BannerErrorEmployeds = ({ content }: { content: string }) => {
  const isDanger = content === 'Бывший сотрудник';
  return (
    <TextWithTooltip
      content={content}
      className={classNames(styles.contractBanner, isDanger && styles.danger)}
    />
  );
};
